export function formatCredits(value: number, digits = 2) {
  return new Intl.NumberFormat("ru-RU", { minimumFractionDigits: digits, maximumFractionDigits: 3 }).format(value);
}

export function slug(text: string) {
  return text.toLowerCase().replace(/[^a-zа-яё0-9]+/gi, "-").replace(/(^-|-$)/g, "");
}

export function relativeDate(value: string) {
  const days = Math.max(0, Math.floor((Date.now() - Date.parse(value)) / 86_400_000));
  if (!days) return "сегодня"; if (days === 1) return "вчера"; if (days < 5) return `${days} дня назад`; if (days < 21) return `${days} дней назад`;
  return new Date(value).toLocaleDateString("ru-RU", { day: "numeric", month: "short" });
}

/** Русское склонение по числу: [1, 2–4, 5–20]. */
export function plural(count: number, forms: [string, string, string]) {
  const tail = count % 10; const teen = count % 100;
  if (tail === 1 && teen !== 11) return forms[0];
  if (tail >= 2 && tail <= 4 && (teen < 10 || teen >= 20)) return forms[1];
  return forms[2];
}

export function initials(name: string) {
  return name.trim().split(/\s+/).slice(0, 2).map((part) => part[0]?.toUpperCase()).join("") || "П";
}
